import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

export const creditNotesRoutes: RouteMetaConfig[] = [
  {
    path: '/credit-notes',
    name: routeNames.creditNoteOverview,
    component: () =>
      import('@manager/modules/credit-notes/views/CreditNotesListView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'credit_notes.view',
      listFilterName: 'credit_notes',
    },
    children: [
      buildModalRoute(
        {
          path: 'export/pdf-export',
          name: routeNames.accountingExportPdfExportCreditNote,
          meta: {
            requiresAuth: true,
            permission: 'credit_notes.export',
          },
          component: () =>
            import('@manager/modules/credit-notes/views/CreditNoteInvoicePdfExport.vue'),
        },
        { fullscreen: false, width: 'md' }
      ),
      buildModalRoute(
        {
          path: 'export',
          name: routeNames.creditNoteExport,
          meta: {
            requiresAuth: true,
            permission: 'credit_notes.export',
          },
          component: () =>
            import('@manager/modules/credit-notes/views/CreditNoteExportView.vue'),
        },
        { fullscreen: false, width: 'unset' }
      ),
    ],
  },
];

export const creditNoteRoutesFactory = {
  creditNoteList() {
    return {
      name: routeNames.creditNoteOverview,
    };
  },
};
